import * as Yup from 'yup';
import { getDefaultItemId, setDefaultImageFromObj, setDefaultPlateFromObj } from 'src/components/formik-utils';

export const validationSchema = (item) => {
  const isCreate = !item?.id;
  const isRequired = true;

  let schema = Yup.object();
  // schema = schema.shape({
  //   price: Yup.number().nullable()
  //     .transform((value, originalValue) => {
  //       if (typeof originalValue === 'string') {
  //         const parsed = parseFloat(originalValue.replace(/,/g, ''));
  //         return isNaN(parsed) ? null : parsed; // Return null instead of an empty string
  //       }
  //       return value;
  //     })
  //     .min(10000, 'Tổng tiền phải lớn hơn 10k')
  //     .when([], {
  //       is: () => isCreate, // Ensure `isCreate` is correctly referenced
  //       then: (schema) => schema.required('Vui lòng nhập tổng tiền'),
  //       otherwise: (schema) => schema.nullable(),
  //     }),
  // });
  
  schema = schema.shape({
    lastKm: Yup.number().nullable()
      .transform((value, originalValue) => {
        if (typeof originalValue === 'string') {
          const parsed = parseFloat(originalValue.replace(/,/g, ''));
          return isNaN(parsed) ? null : parsed; // Return null instead of an empty string
        }
        return value;
      })
      .min(1, 'Km hiện tại phải lớn hơn 1')
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.required('Vui lòng nhập km hiện tại'),
        otherwise: (schema) => schema.nullable(),
      }),
  });

  schema = schema.shape({
    created: Yup.string()
      .nullable()
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.required('Vui lòng chọn ngày bảo dưỡng'),
        otherwise: (schema) => schema.nullable(),
      }),
  });

  schema = schema.shape({
    plateField: Yup.object()
      .nullable()
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.required('Vui lòng chọn biển số'),
        otherwise: (schema) => schema.nullable(),
      }),
  });

  schema = schema.shape({
    serviceField: Yup.array()
      .nullable()
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.min(1, 'Vui lòng chọn ít nhất một mục bảo dưỡng'),
        otherwise: (schema) => schema.nullable(),
      }),
  });

  schema = schema.shape({
    image: Yup.string().nullable().when([], {
      is: () => isRequired,
      then: (schema) => schema.required('Hình yêu cầu phải có'),
      otherwise: (schema) => schema.nullable(),
      }),
  });
    
  return schema;
};

export const handleSubmitted = async (
  values,
  apiCreate,
  apiUpdate,
  apiRemove,
) => {
  
  const isCreate = !values?.id;
  if(isCreate){
    await apiCreate(values);
  }else{
    if (values.isVerified) {
      await apiRemove(values);
    } else {
      await apiUpdate(values);
    }
  }
};

export const initialValues = (formik, item) => {
  if(!formik) return;
  const myId = getDefaultItemId(item);

  if(0 < myId){
    // formik.setFieldValue('created', null);
    formik.setFieldValue('id', myId);
    formik.setFieldValue('lastKm', null);
    // formik.setFieldValue('price', null);

    setDefaultPlateFromObj(formik, item.car);
    setDefaultImageFromObj(formik, item.asset);
    formik.setFieldValue("defaultService", item.services);
  }else{
    // formik.setFieldValue('created', Date.now());
    // formik.setFieldValue('lastKm', 0);
    // formik.setFieldValue('price', 0);
    formik.setFieldValue('serviceField', []);
  }
  
};
